import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=06868f0e&scoped=true&"
import script from "./Payouts.vue?vue&type=script&lang=js&"
export * from "./Payouts.vue?vue&type=script&lang=js&"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=06868f0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06868f0e",
  null
  
)

export default component.exports